module.exports = __webpack_public_path__ + "static/media/souleater.c737098d.mp3";